import { connect } from 'react-redux';
import UpNext from './up-next.component';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import { EMBD_LNK } from '@medscape-promo/medscapetv/omniture-tracking';



const mapStateToProps = (state, ownProps) => {
    let props = ownProps;

    return props;

}

const mapDispatchToProps = dispatch => {
    return {
        onClick: (el) => {
            dispatch(WebViewActions.omnitureTracking(EMBD_LNK, el))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UpNext);